import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { BaseListComponent } from '../base-list/base-list.component';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { NotificationListService } from 'src/app/core/services/list-services/notification-list.service';
import { NotificationModel } from 'src/app/core/models/push/notification.model';
import { Observable } from 'rxjs';
import { NotificationType } from 'src/app/core/enums/notification-type-enum';
import Swal from 'sweetalert2';
import { BadgeCountService } from 'src/app/core/services/badgecount.service';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss'],
  providers: [NotificationListService]
})
export class NotificationsListComponent extends ListLayoutExtendableComponent {

  override rowActionSelected(rowAction: TableActionsModel): void {
    throw new Error('Method not implemented.');
  }
  override buttonActionSelected(buttonAction: any): void {
    throw new Error('Method not implemented.');
  }
  override filterSelected(filterSelected: ListFilterModel): void {
    throw new Error('Method not implemented.');
  }

  protected override searchPlaceHolderText: string = "";
  override listItemsObservable!: Observable<NotificationModel[]>;
  count: number = 0;

  enumNotificationType = NotificationType;

  selectedNotificationFilter: NotificationType | undefined;

  fullListItems: NotificationModel[] = [];

  @Input() notificationType: NotificationType | undefined = undefined;
  @Input() notificationUpdate: boolean = false;

  constructor(
    protected notificationListService: NotificationListService,
    protected badgeCountService: BadgeCountService,
    protected router: Router,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override openModalService: OpenModalService,
    protected override authMyFileService: AuthMyfileService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['notificationUpdate'].currentValue == true) {
      this.serviceSort(this.notificationListService, '', 'desc');
      this.checkedValGet = [];
    }
  }

  ngOnInit(): void {
    this.notificationListService.isRead = false;
    this.listItemsObservable = this.notificationListService.resultItems$;
    this.total = this.notificationListService.total$;
    this.isLoading = this.notificationListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.isLoadingVal = true;
      } else {
        this.isLoadingVal = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);

      this.fullListItems = Object.assign([], this.listItems);
      this.updateSearch(this.selectedNotificationFilter);
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.count = result;
    });
    this.unsubscribe.push(subscr3);
  }

   sanitize(text:string) {
    if(text){
      return this.sanitizer.bypassSecurityTrustHtml(text);
    }
    return ' '
   } 


  ngOnDestroy() {
    this.clearSearch(this.notificationListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  convertDate(date: any): string {
    var convertedDate = new Date(date);
    return convertedDate.toDateString();
  }

  changeReadStatus(notificationId: string) {
    if (notificationId) {
      this.isLoadingVal = true;
      this.myFileApiService.updateNotificationToRead(notificationId).subscribe((result) => {
        this.isLoadingVal = false;
        this.checkedValGet = [];
        this.updateTopBarCount();
        this.serviceSort(this.notificationListService, '', 'desc');
      })
    }
  }

  changeReadStatusMultiple(listLayoutName?: string) {

    if (listLayoutName !== undefined && listLayoutName.length > 0) {
      var checkboxes: any = document.getElementsByName(listLayoutName);
    } else {
      var checkboxes: any = document.getElementsByName('checkAllNotifications');
    }

    var result;
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }
    if (checkedVal.length > 1) {
      for (var i = 0; i < checkedVal.length; i++) {
        var reloadList: number = checkedVal.length;
        this.myFileApiService.updateNotificationToRead(checkedVal[i]).subscribe((result: boolean | undefined) => {
          reloadList = reloadList - 1;
          if (reloadList == 0) {
            this.serviceSort(this.notificationListService, '', 'desc');
            this.updateTopBarCount();
          }
        })
      }
    } else if (checkedVal.length == 1) {
      this.changeReadStatus(checkedVal[0]);
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select a Notification to Mark as Read',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }
    this.masterSelected = false;
    this.checkedValGet = [];
  }

  updateTopBarCount() {
    this.badgeCountService.getBadgeCount();
  }

  updateNotificationType(notificationType: NotificationType | undefined) {
    this.notificationListService.type = notificationType;
  }

  updateSearch(notificationType: NotificationType | undefined) {
    this.selectedNotificationFilter = notificationType;
    if (notificationType != undefined) {
      this.listItems = [];
      this.fullListItems.forEach((notification: NotificationModel) => {
        if (notification.type == this.selectedNotificationFilter) {
          this.listItems.push(notification);
        }
      })
    } else {
      this.listItems = Object.assign([], this.fullListItems);
    }

  }

  updateSearchMultipleTypes(notificationType: NotificationType[] | undefined) {
    this.listItems = [];
    notificationType?.forEach( notificationItem =>{
      if (notificationItem != undefined) {
        this.fullListItems.forEach((notification: NotificationModel) => {
          if (notification.type == notificationItem) {
            this.listItems.push(notification);
          }
        })
      } else {
        this.listItems = Object.assign([], this.fullListItems);
      }
    });
   
  }

  showText(data: any) {
    if (data.showOverFlowText == true) {
      data.showOverFlowText = false;
    } else {
      data.showOverFlowText = true;
    }
  }

  @HostListener("click", ['$event'])
    onClick(event: MouseEvent) {
  
      if (event.target instanceof HTMLAnchorElement === false) {
        return;
      }
  
      event.preventDefault();
      let url = <HTMLAnchorElement>event.target;
  
      var query: string = url.toString().substring(url.toString().indexOf('?') + 1);
      var params: string[] = query.split('&');
  
      var queryParamsModel: any = {};
      params.forEach(pair => {
        var key = pair.split('=')[0];
        var value = pair.split('=')[1];
  
        queryParamsModel = {
          ...queryParamsModel,
          [key]: value
        }
      })
  
      var documentItem = <HTMLElement>document.getElementsByClassName("modal").item(0);
      if (documentItem) {
        documentItem.remove();
      }
  
      documentItem = <HTMLElement>document.getElementsByClassName("modal-backdrop").item(0);
      if (documentItem) {
        documentItem.remove();
      }
  
      documentItem = <HTMLElement>document.getElementsByClassName("modal-open").item(0);
      if (documentItem) {
        documentItem.setAttribute('style', '');
      }
  
      this.router.navigate([url.pathname], { queryParams: queryParamsModel });
    }

}
